import React from 'react';
import { NavLink } from 'react-router-dom';
import SafeIcon from '../common/SafeIcon';
import BrandMark from './BrandMark';
import * as FiIcons from 'react-icons/fi';

const { FiGrid, FiBox, FiTool, FiFileText, FiBarChart2, FiPlayCircle, FiSettings } = FiIcons;

const navItems = [
  { path: '/', icon: FiGrid, label: 'Dashboard' },
  { path: '/portfolio', icon: FiBox, label: 'Portfolio' },
  { path: '/maintenance', icon: FiTool, label: 'Maintenance' },
  { path: '/leases', icon: FiFileText, label: 'Leases' },
  { path: '/reports', icon: FiBarChart2, label: 'Reports' },
  { path: '/demo', icon: FiPlayCircle, label: 'Demo' },
];

export default function Navigation() {
  return (
    <nav className="w-64 h-screen fixed left-0 top-0 tech-panel border-r-0 flex flex-col z-20 hidden md:flex">
      <div className="p-6 border-b border-[#004B87]/20 flex items-center gap-3">
        <BrandMark size="md" className="text-[#004B87]" />
        <div>
          <h1 className="font-bold text-lg leading-none tracking-tight uppercase text-[#004B87]">
            Property<span className="text-[#C1440E]">Pulse</span>
          </h1>
          <p className="text-[9px] uppercase tracking-[0.2em] text-[#004B87]/50 font-mono mt-1">Enterprise v2.4</p>
        </div>
      </div>

      <div className="flex-1 py-6 flex flex-col gap-1 px-3">
        {navItems.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) =>
              `flex items-center gap-3 px-4 py-3 text-[11px] font-bold uppercase tracking-widest transition-all
              ${isActive 
                ? 'bg-[#004B87]/10 text-[#C1440E] border-l-2 border-[#C1440E]' 
                : 'text-[#004B87]/60 hover:bg-[#004B87]/5 hover:text-[#004B87] border-l-2 border-transparent'
              }`
            }
          >
            <SafeIcon icon={item.icon} className="text-base" />
            {item.label}
          </NavLink>
        ))}
      </div>

      <div className="p-4 border-t border-[#004B87]/10">
        <NavLink 
          to="/settings"
          className="flex items-center gap-3 px-4 py-2 text-[10px] text-[#004B87]/50 hover:text-[#C1440E] uppercase tracking-widest transition-colors mb-4"
        >
          <SafeIcon icon={FiSettings} />
          System Settings
        </NavLink>
        <div className="p-3 bg-[#FFFFF0] border border-[#004B87]/20 flex items-center gap-3 tech-border">
          <div className="w-8 h-8 flex-shrink-0 bg-[#004B87] flex items-center justify-center text-[#FFFFF0] font-mono text-xs font-bold">
            JD
          </div>
          <div className="overflow-hidden">
            <p className="font-bold text-[11px] uppercase truncate text-[#004B87]">John Doe</p>
            <p className="text-[9px] uppercase text-[#004B87]/40 font-mono truncate">Apex Administrator</p>
          </div>
        </div>
      </div>
    </nav>
  );
}